<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="globalConfigForm" (ngSubmit)="onSave()">
            <h1 class="heading">
                {{configId ? 'Edit' : 'Add'}}
                 <!-- Add -->
                 <!-- Add -->
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

            <section class="grid gap-4 md:grid-cols-2">

                <!-- title -->
                <!-- <div class="space-y-1">
                    <label class="subheading">
                        Reference <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="reference" />
                        </div>
                    </div>
                    <div *ngIf="form.reference.errors && submitted">
                        <div *ngIf="form.reference.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Reference is required
                            </p>
                        </div>
                    </div>
                </div> -->

                
                  <!-- <div class="space-y-1">
                    <label class="subheading">
                        General Url <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="generalUrl" />
                        </div>
                    </div>
                    <div *ngIf="form.generalUrl.errors && submitted">
                        <div *ngIf="form.generalUrl.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                General Url is required
                            </p>
                        </div>
                    </div>
                </div> -->

                  <!-- <div class="space-y-1">
                    <label class="subheading">
                        Vehicle Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="vehicleUrl" />
                        </div>
                    </div>
                </div> -->

                  <!-- <div class="space-y-1">
                    <label class="subheading">
                        Driver Url
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input type="text" formControlName="driverUrl" />
                        </div>
                    </div>
                </div> -->
                <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">
                        General
                        <!-- Add -->
                    </h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div>
                <div>
                    <label for="company" class="block text-sm font-medium text-main-secondary">Primary Vendor</label>
                    <div class="mt-1">
                        <ng-select id="company" formControlName="primaryCompany" [clearable]="false">
                            <ng-option value="">Select Vendor</ng-option>
                            <ng-option *ngFor="let company of companyList" value="{{ company.id }}">{{
                                company.name | titlecase }}</ng-option>
                        </ng-select>
                    </div>
                </div>

                <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">
                       Quickbook
                        <!-- Add -->
                    </h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div>



                <ng-container formGroupName="quickbooks">
                    <div class="space-y-1">
                        <label class="subheading">
                             Email
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="username" />
                            </div>
                        </div>
                    </div>
                
                    <div class="space-y-1">
                        <label class="subheading">
                             Password
                        </label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="password" />
                            </div>
                        </div>
                    </div>

                    <section class="col-span-full flex flex-wrap gap-4">
                  <div
                        class="flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                        <label class="subheading">Generate Auto Invoice</label>
                        <div class="flex">
                            <label
                                class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                <input type="checkbox" formControlName="isAutoInvoice" class="peer sr-only"
                                    (change)="toggleAutoInvoice($event)"
                                    aria-checked="globalConfigForm.get('quickbooks.isAutoInvoice')?.value" />
                                <span
                                    class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                                    <span *ngIf="!globalConfigForm.get('quickbooks.isAutoInvoice')?.value"
                                        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                        aria-hidden="true">
                                        <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                    <span *ngIf="globalConfigForm.get('quickbooks.isAutoInvoice')?.value"
                                        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                        aria-hidden="true">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="h-3 w-3 text-white">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                    <div
                        class="flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5">
                        <label class="subheading">Auto VEN Accept Billings</label>
                        <div class="flex">
                            <label
                                class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                <input type="checkbox" formControlName="isAutoAccepted" class="peer sr-only"
                                    (change)="toggleAutoAccepted($event)"
                                    aria-checked="globalConfigForm.get('quickbooks.isAutoAccepted')?.value" />
                                <span
                                    class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                                    <span *ngIf="!globalConfigForm.get('quickbooks.isAutoAccepted')?.value"
                                        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                        aria-hidden="true">
                                        <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                    <span *ngIf="globalConfigForm.get('quickbooks.isAutoAccepted')?.value"
                                        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                        aria-hidden="true">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="h-3 w-3 text-white">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                    <div
                        class="flex items-center justify-center border border-dashed border-zinc-950/10 dark:border-white/10 p-1.5 rounded-lg gap-2.5"
                        [ngClass]="{'opacity-50 pointer-events-none': !globalConfigForm.get('quickbooks.isAutoAccepted')?.value}"
                        [title]="globalConfigForm.get('quickbooks.isAutoAccepted')?.value ? '' : 'Enable Auto Accept Billings first'">
                        <label class="subheading">Generate Auto Bill</label>
                        <div class="flex">
                            <label
                                class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                <input type="checkbox" formControlName="isAutoBill" class="peer sr-only"
                                    (change)="toggleAutoBill($event)"
                                    aria-checked="globalConfigForm.get('quickbooks.isAutoBill')?.value" />
                                <span
                                    class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                                    <span *ngIf="!globalConfigForm.get('quickbooks.isAutoBill')?.value"
                                        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                        aria-hidden="true">
                                        <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                            <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                    <span *ngIf="globalConfigForm.get('quickbooks.isAutoBill')?.value"
                                        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                        aria-hidden="true">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="h-3 w-3 text-white">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                    </section>
                </ng-container>

                <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">Jotform</h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div>

                <ng-container formGroupName="jotform">
                    <div class="space-y-1">
                        <label class="subheading">Client ID</label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="clientId" />
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">Secret</label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="secret" />
                            </div>
                        </div>
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">Vehicle Inspection Form ID</label>
                        <div class="flex flex-1 gap-2">
                            <div class="flex-1">
                                <input type="text" formControlName="vehicleInspectionFormId" />
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">Marketplace</h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div>

                <ng-container formGroupName="reserved">
                    <div class="space-y-1">
                        <label for="name" class="subheading">
                            Reserve Time
                        </label>
                        <div class="flex items-center">
                            <input type="text" name="time" id="time" class="" formControlName="time"
                                [owlDateTime]="time" [owlDateTimeTrigger]="time" />
                            <owl-date-time [pickerType]="'timer'" aria-placeholder="time"
                                (afterPickerClosed)="onDateChange(reserved.get('time'))" #time></owl-date-time>

                            <!-- <span
                            class="rounded-r-lg px-[calc(theme(spacing.3)-1px)] py-[calc(theme(spacing[2])-1px)] text-sm border-y border-r border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark">$</span> -->
                        </div>

                    </div>

                </ng-container>

            </section>
            <!-- .....tax -->

            <section class="grid gap-4 md:grid-cols-2 mt-3">
                <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">Tax Information</h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div>

                <ng-container formGroupName="taxInformation">
                    <div class="space-y-1">
                        <label class="subheading">Name</label>
                        <input type="text" formControlName="name" />
                    </div>
                <div class="space-y-1">
                        <label class="subheading">Email</label>
                        <input formControlName="email" type="email" />
                
                    <div *ngIf="submitted && taxInformation.get('email')?.errors">
                        <p *ngIf="taxInformation.get('email')?.errors?.email" class="pt-1 text-red-600 text-xs">
                            Invalid Email format
                        </p>
                    </div>
                </div>

                    <div class="space-y-1">
                        <label class="subheading">NPI</label>
                        <input type="text" formControlName="npi" />
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">Tax ID</label>
                        <input type="text" formControlName="taxId" />
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">Taxonomy</label>
                        <input type="text" formControlName="taxonomy" />
                    </div>
                    <div></div>
                    <div class="space-y-1">
                        <label class="subheading">Profile</label>
                        <div>
                            <div class="relative overflow-hidden rounded-full inline-flex mt-1">
                                <img [src]="imageUrl ? imageUrl : 'assets/images/company-placeholder.png'" alt="Profile Image"
                                    class="relative h-32 w-32 rounded-full border border-main-base" />
                                <label for="Profile"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                    <span>Change</span>
                                    <input #logoInput type="file" accept="image/*" style="width: 100%;" (change)="processFile(logoInput)"
                                        type="file" id="Profile" name="Profile Image"
                                        class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
                                </label>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div class="space-y-1">
                    <label class="subheading">Time Zone</label>
                    <div>
                      <select formControlName="timeZone">
                        <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                      </select>
                      <div *ngIf="submitted && form.timeZone.errors">
                        <p *ngIf="form.timeZone.errors.required" class="pt-1 text-red-600 text-xs">
                          Time Zone is required
                        </p>
                      </div>
                    </div>
                  </div>

                <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">Address</h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div>

                <ng-container formGroupName="address">
                    <div class="space-y-1">
                        <label class="subheading">Street</label>
                        <input type="text" formControlName="name" />
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">City</label>
                        <input type="text" formControlName="city" />
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">State</label>
                        <input type="text" formControlName="state" />
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">Zip Code</label>
                        <input type="text" formControlName="zipCode" />
                    </div>
                </ng-container>

                <div class="space-y-1 col-span-full">
                    <h1 class="heading pb-2">Focal Person Information</h1>
                    <hr class="my-6 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                </div>

                <ng-container formGroupName="focalPersonInformation">
                    <div class="space-y-1">
                        <label class="subheading">Name</label>
                        <input type="text" formControlName="name" />
                    </div>

                    <div class="space-y-1">
                        <label class="subheading">Contact Number</label>
                        <input type="text" formControlName="contactNumber" />
                        <div>
                            <p *ngIf="submitted && (focalPersonInformation.get('contactNumber')?.errors?.minlength || focalPersonInformation.get('contactNumber')?.errors?.maxlength)"
                                class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>
                        </div>
                    </div>
                </ng-container>
            </section>


            <ng-container *ngIf="permissionService.hasPermission([userPermission.MANAGE_CONFIGURATION])">
                <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                <section class="flex justify-end gap-4">
                    <button type="submit" class="btn btn-secondary">
                        {{configId ? 'Update' : 'Create'}}
                        <!-- Save -->
                        <!-- Save -->
                    </button>
                </section>
            </ng-container>
        </form>
    </div>
</section>